import ApiService from './api-service'

class Group extends ApiService {
    constructor() {
        super()

        // this.get = null
        // this.post = null
        this.put = null
        // this.delete = null
    }

    check(options) {
      return super.get('/group/check', options)
    }

    checkAcknowledge(options) {
      return super.post('/group/check/acknowledge', {}, options)
    }

    list(options) {
      return super.get('/group', options)
    }

    listChildren(id, options) {
      return super.get(`/group/${id || `root`}/children`, options)
    }

    listParents(id, options) {
      return super.get(`group/${id}/parents`, options)
    }


    clear(id) {
      if(id) return super.clear(`/group/${id}`)
      return super.clear('/group')
    }


    get(id, options) {
      return super.get(`group/${id}`, options)
    }

    create(payload, options) {
      return super.post(`group`, payload, options)
    }

    update(id, payload, options) {
      return super.put(`group/${id}`, payload, options)
    }

    delete(id, options) {
      return super.delete(`group/${id}`, options)
    }

    archive(id, options) {
      return super.post(`group/${id}/archive`, options)
    }

    archiveMultiple(groups, options) {
      return super.post(`group/archive`, {groups}, options)
    }

    unarchive(id, options) {
      return super.post(`group/${id}/unarchive`, options)
    }

    unarchiveMultiple(groups, options) {
      return super.post(`group/unarchive`, {groups}, options)
    }

    getUser(id, userId, options) {
      return super.get(`group/${id}/user/${userId}`, options)
    }

    getAssignments(id, options) {
      return super.get(`group/${id}/user/assignments`, options)
    }

    assign(id, payload, options) {
      return super.post(`group/${id}/assign`, payload, options)
    }

    unassign(id, payload, options) {
      return super.post(`group/${id}/unassign`, payload, options)
    }

    invite(id, payload, options) {
      return super.post(`group/${id}/invite`, payload, options)
    }

    getInvite(id, inviteId, options) {
      if(!id) return super.get(`group/invite/${inviteId}`, options)
      return super.get(`group/${id}/invite/${inviteId}`, options)
    }

    updateInvite(id, inviteId, payload, options) {
      return super.put(`group/${id}/invite/${inviteId}`, payload, options)
    }

    deleteInvite(id, inviteId, options) {
      return super.delete(`group/${id}/invite/${inviteId}`, options)
    }

    listAllInvites(options) {
      return super.get(`group/invite`, options)
    }

    acceptInvite(inviteId, options) {
      return super.post(`group/invite/${inviteId}/accept`, {}, options)
    }

    declineInvite(inviteId, options) {
      return super.post(`group/invite/${inviteId}/decline`, {}, options)
    }

    joinIdDetails(id, options) {
      return super.post(`group/${id}/join/details`, {}, options)
    }
    joinCodeDetails(accessCode, options) {
      return super.post(`group/join/details`, { accessCode }, options)
    }

    joinId(id, options) {
      return super.post(`group/${id}/join`, {}, options)
    }
    joinCode(accessCode, options) {
      return super.post(`group/join`, { accessCode }, options)
    }

    leave(id, options) {
      return super.post(`group/${id}/leave`, {}, options)
    }

    generateAccessCode(options) {
      return super.get(`accesscode`, options)
    }

    getContentFeed(id, options) {
      return super.get(`group/${id}/feed/content`, options)
    }

    getEventsFeed(id, options) {
      return super.get(`group/${id}/feed/events`, options)
    }
}

const _Group = new Group()
export default _Group
